<template>
  <generic-modal :title="$t('log')" ref="generic_modal" :is_wide="true">
    <generic-table
      ref="datatable"
      :title="$t('api log')"
      :columns="columns"
      :column_search="true"
      mode="table"
      resource_url="/api/log"
      :extra_data="{ api_uuid: api_uuid }"
    >
    </generic-table>
  </generic-modal>
</template>
<script>
import {
  put,
  del,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  generate_datatables_buttons,
  get_currency_settings,
  format_currency,
  format_date,
  format_time,
} from "@/utils";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import GenericModal from "@/components/generic_modal/Index.vue";
// import CustomerInfo from "./Customer.vue";
// import ItemsInfo from "./Items.vue";

export default {
  name: "LogModal",
  components: { GenericModal, GenericTable },
  data() {
    let v = this;
    return {
      api_uuid: "",
      columns: [
        {
          title: v.$t("resource"),
          width: "25%",
          data: (row) => {
            return `<div class="title is-6">${row.endpoint.api.name}</div>
                    <div class="subtitle is-6"><b>${row.endpoint.method}</b> ${row.endpoint.route}</div>`;
          },
        },
        {
          title: v.$t("time marks"),
          width: "25%",
          searchable: false,
          data: (row) => {
            return `<ul>
                      <li>${format_date(row.request_date)} ${format_time(
              row.request_date
            )}</li>
                      <li>${format_date(row.response_date)} ${format_time(
              row.response_date
            )}</li>
                    </ul>`;
            // return `${format_date(row.request_date)} ${format_time(
            //   row.request_date
            // )}`;
          },
        },
        {
          title: v.$t("data"),
          name: "request_data",
          searchable: false,
          width: "50%",
          data: (row) => {
            return `<ul>
                      <li>${v.$t("request")}: ${row.request_data}</li>
                      <li>${v.$t("response")}: ${row.response_data}</li>
                    </ul>`;
          },
        },
        // {
        //   title: v.$t("options"),
        //   searchable: false,
        //   data: (row) => {
        //     return generate_datatables_buttons([
        //       {
        //         args: { uuid: row.uuid },
        //         tooltip: v.$t("view"),
        //         icon: "fa fa-eye",
        //         icon_class: "is-small has-text-info",
        //         click: (e) => {
        //           let uuid = e.detail.uuid;
        //           v.$refs.log_modal.show_modal(uuid);
        //         },
        //       },
        //     ]);
        //   },
        // },
      ],
    };
  },
  computed: {},
  methods: {
    format_date,
    format_time,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(api_uuid) {
      let v = this;
      v.set_initial_state();
      if (api_uuid) {
        v.api_uuid = api_uuid;
        v.$refs.generic_modal.show_modal();
        setTimeout(() => {
          v.$refs.datatable.init();
        }, 300);
      }
    },
    set_initial_state() {
      let v = this;
      v.$refs.datatable.destroy();
      v.api_uuid = "";
    },
  },
  created() {},
  watch: {},
};
</script>
<style></style>
